import React from 'react';

const SchemeAlerts = props => {
  const { datetime, age } = props;

  const getfilmHour = () => {
    // Взять час из строки так, чтобы работало в safari
    const hour = datetime.slice(11, 13);

    if (hour.slice(0, 1) === '0') {
      return hour.slice(1, 2);
    }

    return hour;
  };

  const getfilmDay = () => {
    const day = datetime.slice(8, 10);

    if (day.slice(0, 1) === '0') {
      return day.slice(1, 2);
    }

    return day;
  };

  const filmHour = getfilmHour();
  const filmDay = getfilmDay();

  const isNightFilm = filmHour >= 0 && filmHour < 4 ? true : false;

  const nightAlert = () => {
    if (!isNightFilm) return null;

    return (
      <div className="alert-item alert-item--night">
        {`Показ фильма пройдёт в\u00A0ночь с\u00A0${Number(filmDay) - 1} на
          ${filmDay} число.`}
        {/*<button className="alert-item__close"></button>*/}
      </div>
    );
  };

  const ageAlert = () => {
    if (age !== '18+') return null;

    return (
      <div className="alert-item alert-item--age">
        На входе в зал могут спросить документ
        {/*<button className="alert-item__close"></button>*/}
      </div>
    );
  };

  return (
    <div className="scheme-box__alerts alerts">
      {nightAlert()}
      {ageAlert()}
    </div>
  );
};

export default SchemeAlerts;
